<style>
#delete {
    color: white;
    background-color: rgb(139, 0, 0);
}
</style>

<script>
    export let deleteItem;
    export let hideWidget;
</script>

<p>
You will not be able to undo this action. Please proceed with caution.
</p>
<button on:click={deleteItem} id="delete" onclick={deleteItem}>Confirm Delete</button>
<button on:click={hideWidget}>Cancel</button>